import client from '../../providers/fetchClient'

export const signupPartner = body => client.post('/v3/partners/signup', body)

export const checkCpf = cpf => client.get(`/v3/users/${cpf}/check-cpf`)
